import styled from "styled-components";
import { Colors } from "../../constants/Colors";

export const ErrorContainer = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 1000000;
`;

export const GradientContainerRed = styled.div`
    height: 100%;
    width: 100%;
    background: linear-gradient(to bottom, transparent 0%, ${Colors.stripes.red}CC 50%), repeating-linear-gradient(
        -45deg,                /* Ângulo da listra */
        ${Colors.stripes.darkRed}CC,              /* Azul escuro */
        ${Colors.stripes.darkRed}CC 8px,         /* Tamanho da listra azul escuro */
        ${Colors.stripes.red}CC 8px,         /* Azul claro (começa logo depois) */
        ${Colors.stripes.red}CC 18px          /* Tamanho da listra azul clara */
    ); /* camada superior */

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const ErrorMsg = styled.h1`
  color: ${Colors.commons.white};
  font-size: 3rem;
  font-weight: 400;
  max-width: 90%;
  text-align: center;
`

export const RetryButton = styled.button`
    width: 18rem;
    height: 6rem;
    border: none;
    background-color: ${Colors.secondary[100]};
    border: 2px solid ${Colors.stripes.darkRed};
    color: ${Colors.commons.white};
    font-size: 1.75rem;
    border-radius: 1rem;
    box-shadow: 1rem 1rem 1rem ${Colors.stripes.darkRed};
    cursor: pointer;
`;